import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-skeleton animate-[pulse_0.7s_ease-in-out_infinite] rounded-md', className)}
      {...props}
    />
  );
}

export { Skeleton };
